import logging from '@wr/logging';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {Redirect} from 'react-router';
import {getTrueLayerPaymentStatusClient} from '../../../actions/trueLayer/browser';
import propLoaders from '../../../prop-loaders';
import {redirectTo} from '../../../utils/helpers';
import {useTranslations} from '../../../utils/selectors';
import Spinner from '../../atoms/Spinner';
import {ERROR_STATUS, PAYMENT_STATUS} from './consts';
import {getErrorStatusCode} from './helpers';
import config from '../../../config';

const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);

const TrueLayerStatusWaiting = ({
    initStatusData,
    paymentSessionId,
    errorCode: initialErrorCode,
    match: {params: {language}}
}) => {
    const {
        trueLayer: {
            spinner: {
                title: defaultTitle,
                subTitle
            },
            notFound, unexpectedError
        }
    } = useTranslations();

    const [errorCode, setErrorCode] = useState(initialErrorCode);
    const [statusData, setStatusData] = useState(initStatusData || {});

    let title = defaultTitle;
    let titleClass = 'trueLayer-container__title';

    const hasStatus = status => !errorCode && statusData.paymentStatus === status;


    useEffect(() => {
        const getPaymentStatus = async () => {
            try {
                const newStatusData = await getTrueLayerPaymentStatusClient({paymentSessionId, language});
                setStatusData(newStatusData);
            } catch (err) {
                logger.error(err);
                setErrorCode(getErrorStatusCode(err));
            }
        };

        if (hasStatus(PAYMENT_STATUS.PENDING)) {
            setTimeout(getPaymentStatus, 2000);
        }
        if (hasStatus(PAYMENT_STATUS.DONE)) {
            redirectTo(statusData.redirectUrl);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusData, errorCode, language, paymentSessionId]);

    if (typeof window === 'undefined' && hasStatus(PAYMENT_STATUS.DONE)) {
        return <Redirect to={statusData.redirectUrl} />;
    }

    if (errorCode) {
        if (errorCode === ERROR_STATUS.NOT_FOUND_PAYMENT_ID) {
            title = notFound;
            titleClass += ' trueLayer-container__title--not-found';
        } else {
            title = unexpectedError;
            titleClass += ' trueLayer-container__title--something_wrong';
        }
    }

    return (
        <section className="trueLayer-container">
            <h1 className={titleClass}>
                {title}
            </h1>
            {!errorCode && (
                <>
                    <div className="trueLayer-container__spinner">
                        <Spinner />
                    </div>
                    <h2 className="trueLayer-container__sub-title">
                        {subTitle}
                    </h2>
                </>
            )}
        </section>
    );
};


TrueLayerStatusWaiting.getServerSideProps = async ({
    requestId,
    sessionId,
    query: {single_immediate_payment_id: paymentSessionId}
}) => {
    try {
        const initStatusData = await propLoaders.getTrueLayerPaymentStatus(
            {requestId, sessionId, query: {paymentSessionId}}
        );

        return {
            initStatusData,
            paymentSessionId
        };
    } catch (error) {
        return {
            errorCode: getErrorStatusCode(error),
            initStatusData: {},
            paymentSessionId
        };
    }
};

TrueLayerStatusWaiting.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            language: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    paymentSessionId: PropTypes.string,
    initStatusData: PropTypes.shape({
        redirectUrl: PropTypes.string,
        paymentStatus: PropTypes.oneOf([
            PAYMENT_STATUS.DONE,
            PAYMENT_STATUS.PENDING
        ])
    }),
    errorCode: PropTypes.number
};

TrueLayerStatusWaiting.defaultProps = {
    initStatusData: {},
    paymentSessionId: '',
    errorCode: null
};

export default TrueLayerStatusWaiting;
